import {Params} from '@feathersjs/feathers'

import {anyPermissionExceptOperator} from '../../libs/user'

import {MaterialGroup, Permission} from '../../types'

import * as feathersService from '../feathers'

export const MATERIAL_GROUP = 'materialGroup'

export const get = async (permission: Permission, params?: Params) => {
  if (anyPermissionExceptOperator.includes(permission)) {
    return feathersService.find<MaterialGroup>(MATERIAL_GROUP, params)
  }
  return []
}
